import { useEffect, useState } from 'react';

export default function PreviewBanner() {
    const [show, setShow] = useState(false);
    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        setShow(params.get('preview') === '1');
    }, []);
    if (!show) return null;
    return (
        <div
            data-testid="preview-banner"
            style={{
                position: 'fixed',
                bottom: 24,
                left: '50%',
                transform: 'translateX(-50%)',
                zIndex: 100,
                background: 'var(--ink)',
                color: 'var(--bg)',
                padding: '14px 28px',
                fontFamily: "'Jost', sans-serif",
                fontSize: 10.5,
                letterSpacing: '0.34em',
                textTransform: 'uppercase',
                display: 'flex',
                alignItems: 'center',
                gap: 18,
                boxShadow: '0 12px 40px rgba(20,18,15,0.18)',
            }}
        >
            <span style={{ display: 'inline-block', width: 6, height: 6, borderRadius: '50%', background: '#C07C46' }} />
            Preview mode &nbsp;·&nbsp; unsaved changes
            <button
                onClick={() => {
                    const u = new URL(window.location.href);
                    u.searchParams.delete('preview');
                    window.location.href = u.toString();
                }}
                style={{
                    background: 'transparent',
                    border: '1px solid currentColor',
                    color: 'inherit',
                    padding: '6px 14px',
                    fontFamily: 'inherit',
                    fontSize: 10,
                    letterSpacing: '0.34em',
                    textTransform: 'uppercase',
                    cursor: 'pointer',
                    marginLeft: 8,
                }}
            >
                Exit
            </button>
        </div>
    );
}
